import { render, staticRenderFns } from "./alert-data.vue?vue&type=template&id=3ab661ee&scoped=true&"
import script from "./alert-data.vue?vue&type=script&lang=ts&"
export * from "./alert-data.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab661ee",
  null
  
)

export default component.exports